import {Injectable, TemplateRef} from '@angular/core';
import {OrderItem} from 'src/app/shared/models/layout.model';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    private readonly tabletBreakpoint = 991;
    drawerVisible$ = new BehaviorSubject<boolean>(false);
    isTabletView$ = new BehaviorSubject<boolean>(window.innerWidth <= this.tabletBreakpoint);
    titleKey$ = new BehaviorSubject<{ value: boolean; title: string | null }>({
        value: false,
        title: null as string | null,
    });
    showBackButton$ = new BehaviorSubject<{
        value: boolean;
        route: string | null;
        goBack?: boolean;
    }>({
        value: false,
        route: null as string | null,
        goBack: false,
    });
    titleBarActionsTemplate$ = new BehaviorSubject<TemplateRef<unknown> | null>(null);
    selectedAppCode$ = new BehaviorSubject<string | null>(null);
    selectedAppName$ = new BehaviorSubject<string | null>(null);
    staticMenuInactive = false;
    mobileMenuActive = false;
    topbarMenuActive = false;
    activeMenu = 'Launcher';

    constructor() {
        window.addEventListener('resize', () => {
            this.isTabletView$.next(window.innerWidth <= this.tabletBreakpoint);
        });
    }

    setTitleBarActionsTemplate(template: TemplateRef<unknown> | null): void {
        this.titleBarActionsTemplate$.next(template);
    }

    onMenuToggle(): void {
        if (window.innerWidth > 991) {
            this.staticMenuInactive = !this.staticMenuInactive;
        } else {
            this.mobileMenuActive = !this.mobileMenuActive;
        }
    }

    onTopbarMenuToggle(): void {
        this.topbarMenuActive = !this.topbarMenuActive;
    }

    onMaskClick(): void {
        this.mobileMenuActive = false;
        this.topbarMenuActive = false;
    }

    selectMenu(label: string): void {
        this.activeMenu = label;
    }

    setSelectedAppCode(appCode: string | null): void {
        this.selectedAppCode$.next(appCode);
    }

    setSelectedAppName(appName: string | null): void {
        this.selectedAppName$.next(appName);
    }

    statusSeverity(status: OrderItem['status']): 'success' | 'warn' | 'danger' | 'info' {
        switch (status) {
            case 'Delivered':
                return 'success';
            case 'Refunded':
                return 'danger';
            case 'On Hold':
                return 'warn';
            default:
                return 'info';
        }
    }
}
